import { forwardRef } from 'react'

const GlassCard = forwardRef(function GlassCard(
  { as: Tag = 'div', className = '', interactive = false, style, children, ...rest },
  ref
) {
  const base = 'rounded-2xl border transition-colors'
  const hover = interactive ? 'hover:bg-[var(--dash-surface-hover)]' : ''
  return (
    <Tag
      ref={ref}
      className={`${base} ${hover} ${className}`}
      style={{
        background: 'var(--dash-surface)',
        borderColor: 'var(--dash-border)',
        boxShadow: 'var(--dash-shadow-sm)',
        ...style,
      }}
      {...rest}
    >
      {children}
    </Tag>
  )
})

export default GlassCard
